module.exports = __webpack_public_path__ + "img/fendiye.108691b6.jpg";